import { render } from "./ArtPlaceholder.vue?vue&type=template&id=041de090&scoped=true"
import script from "./ArtPlaceholder.vue?vue&type=script&lang=js"
export * from "./ArtPlaceholder.vue?vue&type=script&lang=js"

import "./ArtPlaceholder.vue?vue&type=style&index=0&id=041de090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041de090"]])

export default __exports__